import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import editUserServices from '../../services/edit-users/edit-users.service';
import { OtherUserModel } from '../../models/all-user/edit-user-model';
import AppLoading from '../app-loading/app-loading';
import TypeSearch from './Complaint-type-search';
import TypeDatatable from './complaint-type-datatable';
import TypeService from '../../services/complaintType/type';

const Typedetails: React.FC = () => {
 
    const { t } = useTranslation();
    const [userList, setUserList] = useState<OtherUserModel[]>([]);
    const [refreshPage, setRefreshPage] = useState(true);
    const [loading, setLoading] = useState(false);
    const [selectedKeyword, setSelectedKeyword] = useState<string>('');
    const [complaintTypes, setComplaintTypes] = useState<any[]>([]);
    const [filteredComplaintTypes, setFilteredComplaintTypes] = useState<any[]>([]); 


    useEffect(() => {
        fetchComplaintTypes(); 
      }, []);
    
      useEffect(() => {
        if (complaintTypes.length > 0) {
          handleSearch(selectedKeyword);
        }
      }, [selectedKeyword, complaintTypes]);

    const fetchComplaintTypes = async () => {
        try {
          const response = await TypeService.getComplaintType();
          setComplaintTypes(response);
          setFilteredComplaintTypes(response); 
        } catch (error) {
          console.error('Error fetching types:', error);
        }
      };

      
 

      const handleSearch = (searchText: string) => {
        const keywords = searchText.toLowerCase().trim().split(/\s+/);
      
        const filtered = complaintTypes.filter((item) => {
          // Convert the whole item to a string and search in that
          const itemText = Object.values(item)
            .join(" ")
            .toLowerCase();
      
          return keywords.every((word) => itemText.includes(word));
        });
      
        setFilteredComplaintTypes(filtered);
      };
      
    
    return (

        <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
            <div className="col-12">                
                <h4 className="ml-1 mb-0">{t('edit_complaint_head')}</h4>
            </div>
        <TypeSearch onSearch={setSelectedKeyword} />
      
        <TypeDatatable complaintTypes={filteredComplaintTypes}/>
        </div>
    );
};

export default Typedetails;